import {Component, NgZone, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material';
import {LanguagesComponent} from '../../languages/languages.component';

@Component({
  selector: 'app-custom-footer',
  templateUrl: './custom-footer.component.html',
  styleUrls: ['./custom-footer.component.scss']
})
export class CustomFooterComponent implements OnInit {

    public lang ;
    public screenW;

    constructor(public ngZone: NgZone, public dialog: MatDialog) {
        if (typeof(window) !== 'undefined') {
            this.lang = localStorage.getItem('lang');
        }
        window.onresize = (e) => {
            this.ngZone.run(() => {
                this.screenW = window.innerWidth;
            });
        };
    }
  openDialog(): void {
    const dialogRef = this.dialog.open(LanguagesComponent, {
      width: '95%',
      maxWidth: '325px'
      //height: '250px'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed', result);
    });
  }
  ngOnInit() {}

}
